import styled from "styled-components";

export const Container: any = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${(props: any) => (props.isError ? "red" : "#C4C4C4")};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SpaceY = styled.div<{ space: number }>`
  height: ${({ space }) => space}px;
`;

export const LightText = styled.p<{ color: string; fontSize: number }>`
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: 150%;
  display: flex;
  color: ${({ color }) => color};
`;
